import { API_BASE_URL } from "./apiConfig";
import { ResourceDto } from "../types/resources";

import { handleUnauthorizedApiResponse } from "./authFetchInterceptor";
import { apiClient } from "./apiClient";

const API_BASE = API_BASE_URL;

function authHeaders() {
    return {
        Accept: "application/json",
        "Content-Type": "application/json",
    };
}

export async function fetchResources(): Promise<ResourceDto[]> {
    const res = await apiClient(`${API_BASE}/api/resources`, {
        method: "GET",
        headers: authHeaders(),
        credentials: "include",
    });

    if (!res.ok) {
        if (res.status === 401 && handleUnauthorizedApiResponse(res.url)) {
            throw new Error("Session expired");
        }
        throw new Error(`Failed to fetch resources: HTTP ${res.status}`);
    }

    return await res.json();
}

export async function fetchCompletedModuleIds(courseId: number): Promise<number[]> {
    const res = await apiClient(
        `${API_BASE}/api/resources/courses/${courseId}/completed-modules`,
        {
            method: "GET",
            headers: authHeaders(),
            credentials: "include",
        }
    );

    if (!res.ok) {
        if (res.status === 401 && handleUnauthorizedApiResponse(res.url)) {
            throw new Error("Session expired");
        }
        throw new Error(`Failed to fetch completed modules: HTTP ${res.status}`);
    }

    return await res.json();
}

export async function markModuleCompleted(courseId: number, moduleId: number): Promise<void> {
    const res = await apiClient(
        `${API_BASE}/api/resources/courses/${courseId}/modules/${moduleId}/complete`,
        {
            method: "POST",
            headers: authHeaders(),
            credentials: "include",
        }
    );

    if (!res.ok) {
        if (res.status === 401 && handleUnauthorizedApiResponse(res.url)) {
            throw new Error("Session expired");
        }
        throw new Error(`Failed to mark module completed: HTTP ${res.status}`);
    }
}

export async function markCourseCompleted(courseId: number): Promise<void> {
    const res = await apiClient(
        `${API_BASE}/api/resources/courses/${courseId}/complete`,
        {
            method: "POST",
            headers: authHeaders(),
            credentials: "include",
        }
    );

    if (!res.ok) {
        if (res.status === 401 && handleUnauthorizedApiResponse(res.url)) {
            throw new Error("Session expired");
        }
        throw new Error(`Failed to mark course completed: HTTP ${res.status}`);
    }
}
